import styled from "styled-components";
export const Description = styled.div `
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 24px;
`;
//# sourceMappingURL=Description.js.map